import React from "react";
import { get } from "react-hook-form";
import MyLabel from "./MyLabel";

const AADHAAR_REGEX = /^[2-9][0-9]{3}[0-9]{4}[0-9]{4}$/;

const MyAadhaar = ({
  title = "Aadhaar Number",
  name = "aadhaar",
  register,
  setValue,
  errors,
  placeholder = "523412341234",
  required = true,
  disabled = false,
  readonly = false,
}) => {
  const error = get(errors, name);

  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setValue(name, value, { shouldValidate: true });
  };

  return (
    <div className="form-group">
      <MyLabel name={name} title={title} required={required} />

      <div className="form-control-wrap">
        <input
          type="text"
          id={name}
          placeholder={placeholder}
          maxLength={12}
          inputMode="numeric"
          {...register(name, {
            required: required
              ? { value: true, message: "Aadhaar number is required" }
              : false,
            pattern: {
              value: AADHAAR_REGEX,
              message: "Aadhaar number must be a valid 12-digit number.",
            },
            minLength: {
              value: 12,
              message: "Aadhaar number must be exactly 12 digits",
            },
            maxLength: {
              value: 12,
              message: "Aadhaar number must be exactly 12 digits",
            },
          })}
          className={`form-control ${error ? "is-invalid" : ""}`}
          onChange={handleChange}
          readOnly={readonly}
          disabled={disabled}
        />

        {error && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {error.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyAadhaar;
